import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';



export default function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        
      >
        Related Topics
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Link to='/BmiCalculator'><MenuItem onClick={handleClose}>BMI Calculator</MenuItem></Link>
        <Link to='/FitnessTracker'><MenuItem onClick={handleClose}>Fitness Tracker</MenuItem></Link>
        <Link to='/CalorieCalculator'><MenuItem onClick={handleClose}>Calorie Calculator</MenuItem></Link>
        
        
      </Menu>
    </div>
  );
}
